<template>
    <div>
        <div class="back"><img src="../assets/overlay.png"> </div>
        <div class="bar-container" ref="bar" layout="row center-justify">

            <logo :scale="scale"/>
            <brrzzz :scale="scale"/>
        </div>
    </div>
</template>

<script>

    import Logo from "./Logo";
    import Brrzzz from "./Brrzzz";

    export default {
        name: "Topbar",
        components: {Brrzzz, Logo},
        data() {
          return {
              tweenedScale:1,
              scale:1
          }
        },
        watch: {

        },
        mounted() {

            let hasBackground = false;

            const fadeIn = (useTween)=> {

              if (hasBackground) return;
              const alpha = 0.5;
              hasBackground = true;
              const bar = this.$refs.bar;
              if (useTween) {
                TweenLite.to(bar, 1, {backgroundColor:`rgba(0,0,0,${alpha})`});
                TweenLite.to(this.$data, 0.3, {scale:0.6});
              } else {
                  bar.style.backgroundColor = `rgba(0,0,0,${alpha})`;
                  this.scale = 0.6;
              }
                this.$emit('fadeIn');
            };


            const fadeOut = (useTween)=> {

                if (!hasBackground) return;
                hasBackground = false;
                const bar = this.$refs.bar;
                if (useTween) {
                    TweenLite.to(bar, 0.3, {backgroundColor:`rgba(0,0,0,0)`});
                    TweenLite.to(this.$data, 0.3, {scale:1});
                } else {
                    bar.style.backgroundColor = `rgba(0,0,0,0)`;
                    this.scale = 1;
                }
                this.$emit('fadeOut');
            };

            if (window.pageYOffset > 50) fadeIn(false);

            window.addEventListener('scroll', ()=>{
                if (window.pageYOffset > 50) {
                    fadeIn(true);
                } else {
                    fadeOut(true);
                }
            });
        }

    }
</script>

<style lang="scss" scoped>


    .back {
        position: absolute;
        z-index:-1;
        opacity: 0.35;
    }

    .back img {
        width:100vw;
        height:11vw;
    }

    .bar-container {
        padding: 15px;
        width:100vw;
        background-color: rgba(0,0,0,0);

        @import '../_vars.scss';

        @media screen and (max-width: $breakpoint_max) {
            padding: 10px;
        }

        @media screen and (max-width: $breakpoint_min) {
            padding: 8px;
        }
    }



</style>